import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import {
    MAT_LEGACY_FORM_FIELD_DEFAULT_OPTIONS as MAT_FORM_FIELD_DEFAULT_OPTIONS,
    MatLegacyFormFieldDefaultOptions as MatFormFieldDefaultOptions
} from '@angular/material/legacy-form-field';
import { ActivatedRoute } from '@angular/router';
import { SbLineChartContext } from '@models';
import { SbDataService, SbEventBusService } from '@services';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';
import { AppConfigQuery } from '../../../core/state/app-config/app-config.query';
import { LocalStorageService } from '../../../shared/services/local-storage.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import {
    MAT_MOMENT_DATE_ADAPTER_OPTIONS,
    MomentDateAdapter
} from '@angular/material-moment-adapter';

// set default form field appearance as fill for this component
const appearance: MatFormFieldDefaultOptions = {
    appearance: 'outline'
};
@Component({
    selector: 'app-sb-linechart',
    templateUrl: './sb-linechart.component.html',
    styleUrls: ['./sb-linechart.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: appearance
        },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                parse: {
                    dateInput: 'YYYY-MM-DD',
                    monthYearLabel: 'YYYY',
                    dateA11yLabel: 'LL',
                    monthYearA11yLabel: 'YYYY'
                },
                display: {
                    dateInput: 'YYYY-MM-DD',
                    monthYearLabel: 'YYYY',
                    dateA11yLabel: 'LL',
                    monthYearA11yLabel: 'YYYY'
                }
            }
        },
        {
            provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
            useValue: {
                useUtc: true
            }
        }
    ]
})
export class SbLinechartComponent
    extends BaseWidgetComponent
    implements OnInit, OnDestroy
{
    @Input() context: SbLineChartContext;
    showMarketValueOverTime: boolean = false;
    dataSeries: any[];
    constructor(
        dataService: SbDataService,
        localStorageService: LocalStorageService,
        eventBus: SbEventBusService,
        activatedRoute: ActivatedRoute,
        private _cdr: ChangeDetectorRef,
        private config: AppConfigQuery
    ) {
        super(dataService, localStorageService, eventBus, activatedRoute);
        // Todo - do we really want to autotrigger dataload here?
        this.autoTriggerDataLoad = true;
        this.responseHandler = this.setData;
    }

    ngOnInit() {
        this.showMarketValueOverTime =
            this.config.get().restrictDashboardChartView === 'marketValue';
        this.dataSeries = [];
        super.ngOnInit();
    }

    private setData(responseData: any) {
        this.dataSeries = Array.isArray(responseData) ? responseData : [responseData];
        this._cdr.detectChanges();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }
}
